import { FuelSavingAnalysis, getIsFuelSavingCardState, getVehicleTabs } from '@makemydeal/dr-activities-fuel-saving';
import { useSelector } from 'react-redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { getBaggageFuelEconomy } from '@makemydeal/dr-dash-store/selectors/baggageFuelEconomySelectors';
import * as offerInfoSelectors from '@makemydeal/dr-dash-store/selectors/offerInfoSelectors';
import { useFuelEconomy, useFuelSavingTrades } from '../hooks';
import { useFuelSavingHandlers } from '../hooks/useFuelSavingHandlers';
import { isScenariosLoading } from '../selectors';

const FuelSavingContainer = () => {
    const isFuelSavingCardState = useSelector(getIsFuelSavingCardState);
    const vehicleTabs = useSelector(getVehicleTabs);
    const { fuelEconomyData, isLoading: isFuelEconomyLoading } = useFuelEconomy();
    const scenariosLoading = useSelector(isScenariosLoading);
    // Show the loader while scenarios are fetching for the first time (0 tabs = no data yet,
    // 1 tab = only the primary vehicle arrived before scenarios). Once scenario vehicles
    // have loaded at least once (>1 tabs), skip the spinner on subsequent fetches (e.g.
    // after Apply triggers a new scenario reload) so the persisted form reopens correctly.
    const isVehicleTabsLoading = isFuelEconomyLoading || (scenariosLoading && vehicleTabs.length <= 1);
    const baggageFuelEconomy = useSelector(getBaggageFuelEconomy);
    const isFuelSavingSaveSuccess = useSelector(
        (state: StateTree) => offerInfoSelectors.getHasBeenSaved(state) || offerInfoSelectors.getHasDraftBeenSaved(state)
    );
    const isFuelSavingSaving = useSelector(
        (state: StateTree) => offerInfoSelectors.getIsOfferBeingSaved(state) || offerInfoSelectors.getIsDraftBeingSaved(state)
    );
    const trades = useFuelSavingTrades();
    const { handleApply, handleApplyAndPrint, handleCancel, handleValuesChange } = useFuelSavingHandlers();

    return (
        <FuelSavingAnalysis
            isFuelSavingCardState={isFuelSavingCardState}
            vehicleTabs={vehicleTabs}
            isVehicleTabsLoading={isVehicleTabsLoading}
            isFuelSavingSaving={isFuelSavingSaving}
            isFuelSavingSaveSuccess={isFuelSavingSaveSuccess}
            trades={trades}
            fuelEconomyData={fuelEconomyData}
            baggageFuelEconomy={baggageFuelEconomy}
            onApply={handleApply}
            onApplyAndPrint={handleApplyAndPrint}
            onCancel={handleCancel}
            onValuesChange={handleValuesChange}
        />
    );
};

export default FuelSavingContainer;
